import { AttendanceActionTypes } from "./attendance.types";
import { docodeHexResponse } from "../../_common/common.utils";

const INITIAL_STATE = {
  attendanceDetails: [],
  isLoading: false,
  error: null,
  attendanceList: null,
  attendanceStatus: "",
  updateAttendanceStatus: "",
  IsAttendanceExist: null,
  downloadAttendanceList: null,
  downloadAttendanceStatus: "",
  downloadAttendanceResponse: null,
  exportAttendanceStatus: "",
  selectAttendanceExportResponse: "",
  selectAttendanceExportResponseArr: [],
};

const attendanceDetails = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case AttendanceActionTypes.FETCH_ATTENDANCE_SUCCESS:
      return {
        ...state,
        attendanceList: docodeHexResponse(
          action.payload,
          "GetUserAttendanceKey",
        ),
        attendanceStatus: "Success",
        IsAttendanceExist: action.payload,
      };
    case AttendanceActionTypes.FETCH_ATTENDANCE_FAILURE:
      return {
        ...state,
        attendanceList: null,
        attendanceStatus: "Failure",
      };
    case AttendanceActionTypes.FETCH_ATTENDANCE_CHANGED:
      return {
        ...state,
        attendanceStatus: "",
      };
    case AttendanceActionTypes.UPDATE_ATTENDANCE_SUCCESS:
      return {
        ...state,
        updateAttendanceStatus: "Success",
        error: null,
      };
    case AttendanceActionTypes.UPDATE_ATTENDANCE_FAILURE:
      return {
        ...state,
        updateAttendanceStatus: "Failure",
        error: action.payload,
      };
    case AttendanceActionTypes.UPDATE_ATTENDANCE_CHANGED:
      return {
        ...state,
        updateAttendanceStatus: "",
      };

    case AttendanceActionTypes.FETCH_ATTENDANCE_DOWNLOAD_DETAILS_SUCCESS:
      return {
        ...state,
        downloadAttendanceList: docodeHexResponse(
          action.payload,
          "GetAttendanceKey",
        ),
        downloadAttendanceStatus: "Success",
        downloadAttendanceResponse: action.payload,
      };
    case AttendanceActionTypes.FETCH_ATTENDANCE_DOWNLOAD_DETAILS_FAILURE:
      return {
        ...state,
        downloadAttendanceList: null,
        downloadAttendanceStatus: "Failure",
      };
    case AttendanceActionTypes.FETCH_ATTENDANCE_DOWNLOAD_DETAILS_CHANGED:
      return {
        ...state,
        downloadAttendanceStatus: "",
      };

    case AttendanceActionTypes.ATTENDANCE_EXPORT_SUCCESS:
      return {
        ...state,
        selectAttendanceExportResponse: action.payload,
        selectAttendanceExportResponseArr: docodeHexResponse(
          action.payload,
          "CreateRequestReportKey",
        ),
        exportAttendanceStatus: "Success",
      };

    case AttendanceActionTypes.ATTENDANCE_EXPORT_FAILURE:
      return {
        ...state,
        selectAttendanceExportResponse: action.payload,
        selectAttendanceExportResponseArr: [],
        exportAttendanceStatus: "Failure",
      };

    case AttendanceActionTypes.ATTENDANCE_EXPORT_CHANGED:
      return {
        ...state,
        selectAttendanceExportResponse: null,
        exportAttendanceStatus: "",
      };
    default:
      return state;
  }
};

export default attendanceDetails;
